/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCompanyDto } from './GetCompanyDto';
import {
    GetCompanyDtoFromJSON,
    GetCompanyDtoFromJSONTyped,
    GetCompanyDtoToJSON,
} from './GetCompanyDto';

/**
 * 
 * @export
 * @interface GetSurveyCompanyDto
 */
export interface GetSurveyCompanyDto {
    /**
     * 
     * @type {string}
     * @memberof GetSurveyCompanyDto
     */
    id: string;
    /**
     * 
     * @type {GetCompanyDto}
     * @memberof GetSurveyCompanyDto
     */
    company: GetCompanyDto;
    /**
     * 
     * @type {string}
     * @memberof GetSurveyCompanyDto
     */
    companyId: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSurveyCompanyDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetSurveyCompanyDto interface.
 */
export function instanceOfGetSurveyCompanyDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "company" in value;
    isInstance = isInstance && "companyId" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetSurveyCompanyDtoFromJSON(json: any): GetSurveyCompanyDto {
    return GetSurveyCompanyDtoFromJSONTyped(json, false);
}

export function GetSurveyCompanyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSurveyCompanyDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'company': GetCompanyDtoFromJSON(json['company']),
        'companyId': json['companyId'],
        'active': json['active'],
    };
}

export function GetSurveyCompanyDtoToJSON(value?: GetSurveyCompanyDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'company': GetCompanyDtoToJSON(value.company),
        'companyId': value.companyId,
        'active': value.active,
    };
}

